// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__L_rrL","selected":"Chip_selected__3mua0"};